import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import AppConst from '../apis/appconst';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import Select from 'react-select';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import QRCode from 'qrcode';

function OpBilling() {
  // ── Auth / User ──
  const [ldata, setLdata] = useState(null);
  const [Name, setName] = useState('');
  const [doctors, setDoctors] = useState([]);
  // ── Patient Search ──
  const [searchInput, setSearchInput] = useState('');
  const [searchLoading, setSearchLoading] = useState(false);
  const [uhidSuggestions, setUhidSuggestions] = useState([]);
  const [noPatientFound, setNoPatientFound] = useState(false);
  const [patientLoaded, setPatientLoaded] = useState(false);
  const searchSeq = useRef(0);
  const searchDebounceRef = useRef(null);

  // ── Multi-patient popup ──
  const [patientResults, setPatientResults] = useState([]);
  const [showPatientModal, setShowPatientModal] = useState(false);

  // ── Patient Details ──
  const [patient, setPatient] = useState({
    opd_id: '', opd_uhid: '', opd_patient_name: '', opd_patient_title: '',
    opd_patient_gender: '', opd_patient_mobile: '', opd_guardien_age: '',
    opd_address: '', opd_city: '', opd_specality: '', opd_concult_doctor: '',
  });

  // ── Active Tab ──
  const [activeTab, setActiveTab] = useState('procedure');

  // ── PROCEDURE BILL TAB ──
  const [serviceOptions, setServiceOptions] = useState([]);
  const [isLoadingServices, setIsLoadingServices] = useState(false);
  const [procItems, setProcItems] = useState([]);
  const [procTotals, setProcTotals] = useState({
    total: '0.00', discount_percent: '0', discount_amount: '0.00',
    final_amount: '0.00', paid_amount: '0.00', original_final: '0.00',
  });
  const [procBillId, setProcBillId] = useState('');
  const [procSaving, setProcSaving] = useState(false);
  const [procPayments, setProcPayments] = useState([]);
  const [showProcPaymentModal, setShowProcPaymentModal] = useState(false);
  const [procPaymentData, setProcPaymentData] = useState({
    amount: 0, payment_mode: 'Cash', received_by: '', remarks: '',
  });
  const [procBillLoaded, setProcBillLoaded] = useState(false);

  // ── INVESTIGATION TAB ──
  const [testSearchKey, setTestSearchKey] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isTestLoading, setIsTestLoading] = useState(false);
  const [showTestDropdown, setShowTestDropdown] = useState(false);
  const [selectedTests, setSelectedTests] = useState([]);
  const [labTotals, setLabTotals] = useState({
    total: '0.00', discount_percent: '0', discount_fixed: '0',
    final_amount: '0.00', paid: '0.00', due: '0.00', pay_mode: 'Cash',
  });
  const [labRegId, setLabRegId] = useState('');
  const [labSaving, setLabSaving] = useState(false);
  const [labRegLoaded, setLabRegLoaded] = useState(false);
  const [labPayments, setLabPayments] = useState([]);
  const testInputRef = useRef(null);

  const [labReferralName, setLabReferralName] = useState('');
  const [labRegDatetime, setLabRegDatetime] = useState('');

  const [testPage, setTestPage] = useState(0);
  const TESTS_PER_PAGE = 5;

  const [showLabPrintModal, setShowLabPrintModal] = useState(false);
  const [showLabPayModal, setShowLabPayModal] = useState(false);
const [labPayData, setLabPayData] = useState({
  amount: '', payment_mode: 'Cash', received_by: '', remarks: '',
});

  const [headerLogo, setHeaderLogo] = useState('');
  const [watermarkLogo, setWatermarkLogo] = useState('');
  const [footerImage, setFooterImage] = useState('');

  useEffect(() => {
    const storedData = sessionStorage.getItem('ldata');
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);
      setName([parsed?.fname, parsed?.lname].filter(Boolean).join(' '));
    }
    fetchServices();
    fetchConfigImages();
    loadDoctors(); 
  }, []);

  const fetchConfigImages = async () => {
    try {
      const res = await axios.post(`${AppConst.BASE_URL}${AppConst.getconfig}?config_type=lab`);
      if (res.data?.status) {
        setHeaderLogo(res.data.header_logo || '');
        setWatermarkLogo(res.data.logo || '');
        setFooterImage(res.data.footer_logo || '');
      }
    } catch (err) { console.error('Config fetch error:', err); }
  };

  // ── PATIENT SEARCH ──
  const runPatientSearch = async (params) => {
    setSearchLoading(true);
    try {
      const fd = new FormData();
      Object.entries(params).forEach(([k, v]) => fd.append(k, v));
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.searchUhidUrlCall, fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      const records = response.data?.records || [];
      if (!response.data?.status || records.length === 0) {
        setUhidSuggestions([]); setNoPatientFound(true); return;
      }
      if (records.length === 1) selectPatient(records[0]);
      else { setPatientResults(records); setShowPatientModal(true); }
      setNoPatientFound(false);
    } catch (err) {
      console.error('Search error:', err);
      setUhidSuggestions([]); setNoPatientFound(true);
    } finally { setSearchLoading(false); }
  };

  const handleSearchInput = (value) => {
    setSearchInput(value);
    setNoPatientFound(false);
    const trimmed = (value || '').trim();
    if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    if (trimmed.length < 2) { setUhidSuggestions([]); return; }

    const isPhone = /^[6-9]\d{9}$/.test(trimmed);
    const isPartialPhone = /^\d+$/.test(trimmed);
    const isUhidLike = /^[A-Za-z]{1,3}\d+/.test(trimmed);

    if (isPhone) {
      searchDebounceRef.current = setTimeout(() => {
        runPatientSearch({ lab_reg_mobile: trimmed });
        setUhidSuggestions([]);
      }, 300);
      return;
    }
    if (isPartialPhone && trimmed.length < 10) { setUhidSuggestions([]); return; }

    if (trimmed.length >= 3) {
      const seq = ++searchSeq.current;
      setSearchLoading(true);
      searchDebounceRef.current = setTimeout(async () => {
        try {
          const fd = new FormData();
          if (isUhidLike) fd.append('lab_reg_uhid', trimmed);
          else fd.append('lab_reg_name', trimmed);
          const response = await axios.post(
            AppConst.BASE_URL + AppConst.searchUhidUrlCall, fd,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          );
          if (seq !== searchSeq.current) return;
          const records = response.data?.records;
          if (response.data?.status && Array.isArray(records) && records.length > 0) {
            setUhidSuggestions(records); setNoPatientFound(false);
          } else { setUhidSuggestions([]); setNoPatientFound(true); }
        } catch (err) {
          if (seq !== searchSeq.current) return;
          console.error('Search error:', err);
          setUhidSuggestions([]); setNoPatientFound(true);
        } finally {
          if (seq === searchSeq.current) setSearchLoading(false);
        }
      }, 400);
    } else { setUhidSuggestions([]); setSearchLoading(false); }
  };

  const selectPatient = async (p) => {
    const patientData = {
        opd_id: p.opd_id || p.lab_reg_id || '',
        ipd_bill_id: p.ipd_bill_id || '',          // ✅ now comes from backend
        ipd_no: p.ipd_no || p.ipd_id || '', 
        opd_uhid: p.opd_uhid || p.lab_reg_uhid || p.uhid || '',
        opd_patient_name: p.opd_patient_name || p.lab_reg_name || p.patient_name || '',
        opd_patient_title: p.opd_patient_title || p.lab_reg_name_title || '',
        opd_patient_gender: p.opd_patient_gender || p.lab_reg_gender || '',
        opd_patient_mobile: p.opd_patient_mobile || p.lab_reg_mobile || p.mobile || '',
        opd_guardien_age: p.opd_guardien_age || p.lab_reg_age_year || p.age || '',
        opd_age_month: p.lab_reg_age_month || '',      // ← add
        opd_age_day: p.lab_reg_age_day || '',          // ← add
        opd_address: p.opd_address || p.lab_reg_address || '',
        opd_city: p.opd_city || p.lab_reg_city || '',
        opd_specality: p.opd_specality || '',
        opd_concult_doctor: p.opd_concult_doctor || p.lab_reg_referral || '',
        opd_referral_name: p.lab_reg_referral || p.opd_concult_doctor || '',  // ← add
      };
    setPatient(patientData);
    setUhidSuggestions([]);
    setSearchInput(patientData.opd_uhid);
    setPatientLoaded(true);
    setNoPatientFound(false);
    setShowPatientModal(false);
    setLabReferralName('');
setLabRegDatetime('');
    setProcItems([]); setProcBillId(''); setProcBillLoaded(false); setProcPayments([]); resetProcTotals();
    setSelectedTests([]); setLabRegId(''); setLabRegLoaded(false); setLabPayments([]); resetLabTotals();
    await fetchExistingProcBill(patientData.opd_uhid);
    await fetchExistingLabReg(patientData.opd_uhid);
    toast.success(`Patient loaded: ${patientData.opd_patient_name}`);
  };

  const clearPatient = () => {
    setPatient({
      opd_id: '', opd_uhid: '', opd_patient_name: '', opd_patient_title: '',
      opd_patient_gender: '', opd_patient_mobile: '', opd_guardien_age: '',
      opd_address: '', opd_city: '', opd_specality: '', opd_concult_doctor: '',
    });
    setSearchInput(''); setPatientLoaded(false); setNoPatientFound(false); setUhidSuggestions([]);
    setProcItems([]); setProcBillId(''); setProcBillLoaded(false); setProcPayments([]); resetProcTotals();
    setSelectedTests([]); setLabRegId(''); setLabRegLoaded(false); setLabPayments([]); resetLabTotals(); setLabReferralName('');
    setLabRegDatetime('');
  };

  // ── PROCEDURE services ──
  const fetchServices = async (inputValue = '') => {
    setIsLoadingServices(true);
    try {
      const fd = new FormData();
      fd.append('cat_type', 'service'); fd.append('page_no', 'none');
      fd.append('search_key', inputValue); fd.append('par_by', '1');
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.getCatListUrl, fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      if (response?.data?.status && Array.isArray(response.data.records)) {
        setServiceOptions(response.data.records.map(srv => ({
          value: srv.cat_id || srv.id,
          label: `${srv.cat_name || srv.name} — ₹${Number(srv.cat_price || srv.price || 0)}`,
          price: Number(srv.cat_price || srv.price || 0),
          serviceData: srv,
        })));
      }
    } catch (err) { console.error('Fetch services error:', err); }
    finally { setIsLoadingServices(false); }
  };



  const loadDoctors = async () => {
    try {
      const fd = new FormData();
      fd.append('type', 'doctor');
      fd.append('search_key', '');
      fd.append('page_no', 'none');
      fd.append('user_cre_by', '1');
      const res = await axios.post(
        AppConst.BASE_URL + AppConst.getUserListUrl, fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      if (res.data?.status && Array.isArray(res.data.records)) {
        setDoctors(res.data.records);
      }
    } catch (e) { console.error('loadDoctors error', e); }
  };


  const getDoctorNameById = (id) => {
    if (id === null || id === undefined || id === '') return '';
    const idStr = String(id).trim();
    const doc = (doctors || []).find(d =>
      String(d.user_id ?? d.id ?? '').trim() === idStr
    );
    if (!doc) return '';
    return [doc.fname, doc.lname].filter(Boolean).join(' ') || '';
  };

  const handleServiceSelect = (selectedOption) => {
    if (!selectedOption) return;
    const srv = selectedOption.serviceData;
    const price = Number(srv.cat_price || srv.price || 0);
    const newItem = {
      service_id: srv.cat_id || srv.id, service_name: srv.cat_name || srv.name,
      qty: 1, unit_price: price, discount: 0, final_price: price,
    };
    const updated = [...procItems, newItem];
    setProcItems(updated);
    recalcProcTotals(updated, procTotals.discount_percent);
    toast.success(`${newItem.service_name} added`);
  };

  const handleProcItemChange = (index, field, value) => {
    const updated = [...procItems];
    updated[index] = { ...updated[index], [field]: value };
    const item = updated[index];
    item.final_price = (Number(item.qty || 0) * Number(item.unit_price || 0)) - Number(item.discount || 0);
    setProcItems(updated);
    recalcProcTotals(updated, procTotals.discount_percent);
  };

  const removeProcItem = (index) => {
    const updated = procItems.filter((_, i) => i !== index);
    setProcItems(updated);
    recalcProcTotals(updated, procTotals.discount_percent);
  };

  const recalcProcTotals = (items, discountPct, discountAmtDirect = null) => {
    const total = items.reduce((sum, it) => sum + Number(it.final_price || 0), 0);
    const pct = Number(discountPct || 0);
    let discountAmt = discountAmtDirect !== null ? Number(discountAmtDirect) : (total * pct) / 100;
    if (discountAmt > total) discountAmt = total;
    const finalAmt = total - discountAmt;
    const paid = Number(procTotals.paid_amount || 0);
    const remaining = Math.max(0, finalAmt - paid);
    setProcTotals(prev => ({
      ...prev,
      total: total.toFixed(2),
      discount_amount: discountAmt.toFixed(2),
      discount_percent: discountAmtDirect !== null ? (total > 0 ? ((discountAmt / total) * 100).toFixed(2) : '0') : String(pct),
      final_amount: remaining.toFixed(2),
      original_final: finalAmt.toFixed(2),
    }));
  };

  const resetProcTotals = () => setProcTotals({
    total: '0.00', discount_percent: '0', discount_amount: '0.00',
    final_amount: '0.00', paid_amount: '0.00', original_final: '0.00',
  });

  const fetchExistingProcBill = async (uhid) => {
    if (!uhid) return;
    try {
      const fd = new FormData();
      fd.append('uhid', uhid);
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.getProcedureBillUrl, fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      if (response?.data?.status && response.data.bill) {
        const bill = response.data.bill;
        const items = (response.data.items || []).map(item => ({
          service_id: item.service_id || item.item_id,
          service_name: item.service_name || item.item_name,
          qty: Number(item.qty || item.quantity || 1),
          unit_price: Number(item.unit_price || item.price || 0),
          discount: Number(item.discount || 0),
          final_price: Number(item.final_price || item.total || 0),
        }));
        const payments = response.data.payments || [];
        const paidAmount = Number(response.data.payment_summary?.total_paid || 0);
        const total = items.reduce((s, it) => s + Number(it.final_price || 0), 0);
        const discPct = Number(bill.discount_percent || 0);
        const discAmt = (total * discPct) / 100;
        const finalAmt = total - discAmt;
        const remaining = Math.max(0, finalAmt - paidAmount);
        setProcBillId(bill.procedure_bill_id || '');
        setProcItems(items);
        setProcPayments(payments);
        setProcBillLoaded(true);
        setProcTotals({
          total: total.toFixed(2), discount_percent: String(discPct),
          discount_amount: discAmt.toFixed(2), final_amount: remaining.toFixed(2),
          paid_amount: paidAmount.toFixed(2), original_final: finalAmt.toFixed(2),
        });
      }
    } catch (err) { console.error('Fetch procedure bill error:', err); }
  };

  const saveProcedureBill = async () => {
    if (procItems.length === 0) { toast.error('Please add at least one procedure/service'); return; }
    if (!patient.opd_uhid) { toast.error('Please search and select a patient first'); return; }
    setProcSaving(true);
    Swal.fire({ title: 'Saving...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
    try {
      const fd = new FormData();
      if (procBillId) fd.append('procedure_bill_id', procBillId);
      fd.append('ipd_bill_uhid', patient.opd_uhid);
      fd.append('ipd_bill_id', patient.ipd_bill_id || patient.opd_id || '');
      fd.append('ipd_no', patient.ipd_no || patient.opd_id || '');
      fd.append('patient_name', `${patient.opd_patient_title} ${patient.opd_patient_name}`.trim());
      fd.append('patient_age', patient.opd_guardien_age || '');
      fd.append('patient_gender', patient.opd_patient_gender || '');
      fd.append('patient_phone', patient.opd_patient_mobile || '');
      fd.append('patient_address', patient.opd_address || '');
      fd.append('bill_date', new Date().toISOString().slice(0, 16));
      fd.append('total_amount', procTotals.total);
      fd.append('discount_percent', procTotals.discount_percent);
      fd.append('discount_amount', procTotals.discount_amount);
      fd.append('final_amount', procTotals.original_final);
      fd.append('payment_mode', 'Cash');
      fd.append('remarks', '');
      fd.append('items', JSON.stringify(procItems));
      fd.append('opd_user', ldata?.user_id || '1');
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.saveProcedureBillUrl, fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      Swal.close();
      if (response.data?.status) {
        const billId = response.data.procedure_bill_id || response.data.bill?.procedure_bill_id || procBillId;
        setProcBillId(billId); setProcBillLoaded(true);
        toast.success(response.data.message || 'Procedure bill saved successfully');
        await fetchExistingProcBill(patient.opd_uhid);
      } else { toast.error(response.data?.message || 'Failed to save procedure bill'); }
    } catch (err) {
      Swal.close(); console.error('Save procedure bill error:', err);
      toast.error('Failed to save procedure bill');
    } finally { setProcSaving(false); }
  };

  const handleProcPayment = () => {
    const due = parseFloat(procTotals.final_amount);
    if (due <= 0) { toast.info('No due amount'); return; }
    let receivedBy = '';
    try {
      const u = JSON.parse(sessionStorage.getItem('ldata') || '{}');
      receivedBy = `${u.fname || ''} ${u.lname || ''}`.trim() || u.user_name || 'User';
    } catch (e) { receivedBy = 'User'; }
    setProcPaymentData({ amount: due, payment_mode: 'Cash', received_by: receivedBy, remarks: '' });
    setShowProcPaymentModal(true);
  };

  const processProcPayment = async () => {
    const amt = parseFloat(procPaymentData.amount || 0);
    const due = parseFloat(procTotals.final_amount || 0);
    if (amt <= 0) { toast.error('Enter a valid amount'); return; }
    if (amt > due) { toast.error(`Amount cannot exceed ₹${due.toFixed(2)}`); return; }
    if (!procBillId) { toast.error('Save the bill first'); return; }
    setProcSaving(true);
    try {
      const fd = new FormData();
      fd.append('procedure_bill_id', procBillId);
      fd.append('amount', String(amt));
      fd.append('payment_mode', procPaymentData.payment_mode);
      fd.append('remarks', procPaymentData.remarks || '');
      try {
        const u = JSON.parse(sessionStorage.getItem('ldata') || '{}');
        fd.append('received_by', u.user_id || '');
        fd.append('received_by_name', `${u.fname || ''} ${u.lname || ''}`.trim());
        fd.append('opd_user', u.user_id || '');
      } catch (e) { }
      const res = await axios.post(
        AppConst.BASE_URL + AppConst.payProcedureBillUrl, fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      if (res.data?.status) {
        toast.success(res.data.message || 'Payment recorded');
        setShowProcPaymentModal(false);
        await fetchExistingProcBill(patient.opd_uhid);
      } else { toast.error(res.data?.message || 'Payment failed'); }
    } catch (err) {
      console.error('Procedure payment error:', err); toast.error('Payment failed');
    } finally { setProcSaving(false); }
  };



  const handleLabPayClick = () => {
    const due = parseFloat(labTotals.due || 0);
    if (due <= 0) { toast.info('No due amount'); return; }
    let receivedBy = '';
    try {
      const u = JSON.parse(sessionStorage.getItem('ldata') || '{}');
      receivedBy = `${u.fname || ''} ${u.lname || ''}`.trim() || u.user_name || 'User';
    } catch (e) { receivedBy = 'User'; }
    setLabPayData({ amount: due.toFixed(2), payment_mode: 'Cash', received_by: receivedBy, remarks: '' });
    setShowLabPayModal(true);
  };
  
  const processLabPayment = async () => {
    const amt = parseFloat(String(labPayData.amount).replace(/[,₹\s]/g, '') || 0);
    const due = parseFloat(labTotals.due || 0);
    if (amt <= 0 || isNaN(amt)) { toast.error('Enter a valid amount'); return; }
    if (amt > due) { toast.error(`Amount cannot exceed ₹${due.toFixed(2)}`); return; }
    if (!labRegId) { toast.error('Save the investigation first'); return; }
  
    setLabSaving(true);
    try {
      const fd = new FormData();
      fd.append('lab_reg_id', labRegId);
      fd.append('payment_amount', String(amt));
      fd.append('payment_mode', labPayData.payment_mode);
      fd.append('payment_received_by', labPayData.received_by || '');
      fd.append('payment_remarks', labPayData.remarks || '');
      fd.append('user_id', ldata?.user_id || '1');
  
      const res = await axios.post(
        AppConst.BASE_URL + AppConst.addPaymentUrl, fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
  
      if (res.data?.status) {
        toast.success(res.data.success || 'Payment recorded');
        setShowLabPayModal(false);
        await fetchExistingLabReg(patient.opd_uhid);
      } else {
        toast.error(res.data?.success || 'Payment failed');
      }
    } catch (err) {
      console.error('Lab payment error:', err);
      toast.error('Payment failed');
    } finally {
      setLabSaving(false);
    }
  };
  // ── INVESTIGATION tests ──
  const fetchTests = async (key) => {
    setIsTestLoading(true);
    try {
      const fd = new FormData();
      fd.append('search_key', key || ''); fd.append('page_no', 'none'); fd.append('test_user', '1');
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.getTestListUrl, fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      if (response.data?.status && Array.isArray(response.data.records)) setSearchResults(response.data.records);
      else setSearchResults([]);
    } catch (err) { console.error('Fetch tests error:', err); setSearchResults([]); }
    finally { setIsTestLoading(false); }
  };

  const handleTestSearch = (value) => {
    setTestSearchKey(value); setShowTestDropdown(true); setTestPage(0); fetchTests(value);
  };

  const addTest = async (test) => {
    const testId = String(test.test_id || test.id || '').trim();
    const testName = test.test_name || test.name || '';
    const testPrice = Number(test.test_price || test.price || 0);
  
    const exists = selectedTests.some(t => String(t.test_id || '').trim() === testId && testId !== '');
  
    if (exists) {
      const result = await Swal.fire({
        title: 'Test Already Added',
        html: `<p>The test "<strong>${testName}</strong>" is already in the list.</p><p>Do you want to add it again?</p>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Add Again',
        cancelButtonText: 'No, Cancel',
      });
      if (!result.isConfirmed) return;
    }
  
    const newTest = {
      test_id: testId,
      row_uid: `${testId || 't'}-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
      test_name: testName,
      test_price: testPrice,
      test_discount: 0,
      lab_item_total: testPrice,
      cat_name: test.cat_name || '',
    };
  
    const updated = [...selectedTests, newTest];
    setSelectedTests(updated);
    recalcLabTotals(updated);
    setTestSearchKey('');
    setTestPage(0);
  };

  const removeTest = (index) => {
    const updated = selectedTests.filter((_, i) => i !== index);
    setSelectedTests(updated); recalcLabTotals(updated);
  };

  const handleTestDiscountChange = (index, value) => {
    const updated = [...selectedTests];
    const disc = Number(value || 0);
    updated[index].test_discount = disc;
    const price = Number(updated[index].test_price || 0);
    updated[index].lab_item_total = Math.max(price - disc, 0);
    setSelectedTests(updated); recalcLabTotals(updated);
  };

  const recalcLabTotals = (tests, discPct = null, discFixed = null) => {
    const total = tests.reduce((sum, t) => sum + Number(t.lab_item_total || t.test_price || 0), 0);
    const pct = discPct !== null ? Number(discPct) : Number(labTotals.discount_percent || 0);
    const fixed = discFixed !== null ? Number(discFixed) : Number(labTotals.discount_fixed || 0);
    let afterDiscount = total;
    if (pct > 0) afterDiscount -= (afterDiscount * pct) / 100;
    if (fixed > 0) afterDiscount -= fixed;
    if (afterDiscount < 0) afterDiscount = 0;
    const paid = Number(labTotals.paid || 0);
    const due = afterDiscount - paid;
    setLabTotals(prev => ({
      ...prev,
      total: total.toFixed(2),
      discount_percent: discPct !== null ? String(pct) : prev.discount_percent,
      discount_fixed: discFixed !== null ? String(fixed) : prev.discount_fixed,
      final_amount: afterDiscount.toFixed(2),
      due: Math.max(0, due).toFixed(2),
    }));
  };

  const resetLabTotals = () => setLabTotals({
    total: '0.00', discount_percent: '0', discount_fixed: '0',
    final_amount: '0.00', paid: '0.00', due: '0.00', pay_mode: 'Cash',
  });

  const fetchExistingLabReg = async (uhid) => {
    if (!uhid) return;
    try {
      const fd = new FormData();
      fd.append('search_key', uhid); fd.append('page_no', 'none'); fd.append('lab_reg_user', 'all');
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.getLabRegListUrl, fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      if (response?.data?.status && Array.isArray(response.data.records)) {
        const regs = response.data.records.filter(r => (r.lab_reg_uhid || '').trim() === uhid.trim());
        if (regs.length > 0) {
          regs.sort((a, b) => new Date(b.lab_reg_datetime || 0) - new Date(a.lab_reg_datetime || 0));
          const latestReg = regs[0];
          setLabRegId(latestReg.lab_reg_id || ''); setLabRegLoaded(true);
          if (Array.isArray(latestReg.tests) && latestReg.tests.length > 0) applyLabRegRecord(latestReg, latestReg.tests);
          else await fetchLabRegItems(latestReg.lab_reg_id, latestReg);
          fetchLabPaymentHistory(latestReg.lab_reg_id);
        }
      }
    } catch (err) { console.error('Fetch lab reg error:', err); }
  };

  const applyLabRegRecord = (reg, items) => {
    const tests = (items || []).map((it, i) => ({  
        row_uid: `${it.lab_item_test_id || it.test_id || 'r'}-${i}-${Date.now()}`,
      test_id: String(it.lab_item_test_id || it.test_id || ''),
      test_name: it.lab_item_test_name || it.test_name || '',
      test_price: Number(it.lab_item_test_price || it.test_price || 0),
      test_discount: Number(it.lab_item_dis_per || it.test_discount || 0),
      lab_item_total: Number(it.lab_item_total || it.lab_item_test_price || it.test_price || 0),
      cat_name: it.test_dept_name || it.cat_name || '',
    }));
    setSelectedTests(tests);
    setLabReferralName(reg.lab_reg_referral || '');
setLabRegDatetime(reg.lab_reg_datetime || reg.lab_reg_date || '');

    setLabTotals({
      total: String(Number(reg.lab_total || 0).toFixed(2)),
      discount_percent: String(reg.lab_dis_per || '0'),
      discount_fixed: String(reg.lab_fix_deposit || '0'),
      final_amount: String(Number(reg.lab_final_amt || 0).toFixed(2)),
      paid: String(Number(reg.lab_paid || 0).toFixed(2)),
      due: String(Number(reg.lab_due || 0).toFixed(2)),
      pay_mode: reg.lab_pay_mode || 'Cash',
    });
  };

  const fetchLabRegItems = async (regId, regRecord = null) => {
    if (!regId) return;
    try {
      const fd = new FormData();
      fd.append('lab_reg_id', regId);
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.getLabRegListItmUrl, fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      if (response?.data?.status && Array.isArray(response.data.records)) {
        const items = response.data.records;
        let reg = regRecord;
        if (!reg) {
          try {
            const fd2 = new FormData();
            fd2.append('lab_reg_id', regId);
            const regRes = await axios.post(
              AppConst.BASE_URL + AppConst.getLabRegByIdUrl, fd2,
              { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            if (regRes?.data?.status && regRes.data.record) reg = regRes.data.record;
          } catch (e) { }
        }
        if (reg) applyLabRegRecord(reg, items);
        else {
            const tests = items.map((it, i) => ({    
            row_uid: `${it.lab_item_test_id || it.test_id || 'r'}-${i}-${Date.now()}`,
            test_id: String(it.lab_item_test_id || it.test_id || ''),
            test_name: it.lab_item_test_name || it.test_name || '',
            test_price: Number(it.lab_item_test_price || it.test_price || 0),
            test_discount: Number(it.lab_item_dis_per || it.test_discount || 0),
            lab_item_total: Number(it.lab_item_total || it.test_price || 0),
            cat_name: it.test_dept_name || it.cat_name || '',
          }));
          setSelectedTests(tests); recalcLabTotals(tests);
        }
      }
    } catch (err) { console.error('Fetch lab items error:', err); }
  };

  const fetchLabPaymentHistory = async (regId) => {
    if (!regId || !AppConst.getPaymentHistoryUrl) return;
    try {
      const fd = new FormData();
      fd.append('lab_reg_id', regId);
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.getPaymentHistoryUrl, fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      if (response.data?.status) setLabPayments(response.data.records || []);
    } catch (err) { console.error('Fetch lab payments error:', err); }
  };

  const saveInvestigation = async () => {
    if (selectedTests.length === 0) { toast.error('Please add at least one test'); return; }
    if (!patient.opd_uhid) { toast.error('Please search and select a patient first'); return; }
    setLabSaving(true);
    Swal.fire({ title: 'Saving...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
    try {
      const fd = new FormData();
      if (labRegId) fd.append('lab_reg_id', labRegId);
      fd.append('lab_reg_uhid', patient.opd_uhid);
      fd.append('ipd_id', patient.ipd_bill_id || patient.ipd_no || patient.opd_id || '');
      fd.append('lab_reg_name_title', patient.opd_patient_title || 'Mr.');
      fd.append('lab_reg_name', patient.opd_patient_name || '');
      fd.append('lab_reg_gender', patient.opd_patient_gender || '');
      fd.append('lab_reg_mobile', patient.opd_patient_mobile || '');
      fd.append('lab_reg_address', patient.opd_address || '');
      fd.append('lab_reg_city', patient.opd_city || '');
      fd.append('lab_reg_age_year', patient.opd_guardien_age || '');
      fd.append('lab_reg_age_month', ''); fd.append('lab_reg_age_day', '');
      fd.append('lab_reg_type', 'OPD'); fd.append('lab_reg_state', '');
      fd.append('lab_reg_referral', patient.opd_concult_doctor || '');
      fd.append('lab_reg_sample', '');
      fd.append('lab_reg_date', new Date().toISOString().split('T')[0]);
      fd.append('lab_guardian_title', ''); fd.append('lab_guardian_name', ''); fd.append('lab_collected_at', '');
      const itemsWithTotal = selectedTests.map(t => ({ ...t, lab_item_total: t.lab_item_total || t.test_price }));
      fd.append('lab_items', JSON.stringify(itemsWithTotal));
      fd.append('lab_total', labTotals.total);
      fd.append('lab_dis_per', labTotals.discount_percent);
      fd.append('lab_fix_deposit', labTotals.discount_fixed);
      fd.append('lab_final_amt', labTotals.final_amount);
      fd.append('lab_paid', labTotals.paid);
      fd.append('lab_due', labTotals.due);
      fd.append('lab_pay_mode', labTotals.pay_mode);
      fd.append('lab_remarks', '');
      fd.append('lab_reg_user', ldata?.user_id || '1');
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.addLabRegUrl, fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      Swal.close();
      if (response.data?.status) {
        const newRegId = response.data.lab_reg_dt?.lab_reg_id || labRegId;
        setLabRegId(newRegId); setLabRegLoaded(true);
        toast.success('Investigation saved successfully');
        await fetchExistingLabReg(patient.opd_uhid);
      } else { toast.error(response.data?.success || 'Failed to save investigation'); }
    } catch (err) {
      Swal.close(); console.error('Save investigation error:', err);
      toast.error('Failed to save investigation');
    } finally { setLabSaving(false); }
  };

  // ── SHARED PDF HELPERS ──
  const imageUrlToBase64 = async (url) => {
    if (!url) return null;
    try {
      const response = await fetch(url);
      if (!response.ok) return null;
      const blob = await response.blob();
      if (!blob.type.startsWith('image/')) return null;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (e) { console.error('imageUrlToBase64 error', e); return null; }
  };

  const formatDateDisplay = (dateString) => {
    if (!dateString) return '';
    try {
      const d = new Date(dateString);
      if (isNaN(d.getTime())) return String(dateString);
      return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
    } catch (e) { return String(dateString); }
  };







  const formatDateTimeDisplay = (dateInput) => {
    let d;
    if (!dateInput) {
      d = new Date();
    } else if (typeof dateInput === 'string' && dateInput.includes(' ') && !dateInput.includes('T')) {
      // MySQL "YYYY-MM-DD HH:mm:ss" → make it ISO-ish for reliable parsing
      d = new Date(dateInput.replace(' ', 'T'));
    } else {
      d = new Date(dateInput);
    }
    if (isNaN(d.getTime())) return '';
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const dd = String(d.getDate()).padStart(2, '0');
    const mon = months[d.getMonth()];
    const yyyy = d.getFullYear();
    let h = d.getHours();
    const min = String(d.getMinutes()).padStart(2, '0');
    const ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12; if (h === 0) h = 12;
    return `${dd} ${mon} ${yyyy}, ${h}:${min} ${ampm}`;
  };

  const amountInWords = (amount) => {
    const num = parseFloat(amount);
    if (isNaN(num) || num === 0) return 'Zero';
    const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const convert = (n) => {
      if (n === 0) return '';
      let res = '';
      const h = Math.floor(n / 100);
      if (h > 0) { res += units[h] + ' Hundred '; n %= 100; }
      if (n > 0) {
        if (res !== '') res += 'and ';
        if (n < 10) res += units[n];
        else if (n < 20) res += teens[n - 10];
        else { res += tens[Math.floor(n / 10)]; if (n % 10 > 0) res += ' ' + units[n % 10]; }
      }
      return res.trim();
    };
    let result = '', n = Math.round(num);
    const cr = Math.floor(n / 10000000); if (cr > 0) { result += convert(cr) + ' Crore '; n %= 10000000; }
    const la = Math.floor(n / 100000); if (la > 0) { result += convert(la) + ' Lakh '; n %= 100000; }
    const th = Math.floor(n / 1000); if (th > 0) { result += convert(th) + ' Thousand '; n %= 1000; }
    result += convert(n);
    return result.trim() || 'Zero';
  };

  const getAgeDisplay = () => {
    const y = parseInt(String(patient.opd_guardien_age || '').trim(), 10) || 0;
    const m = parseInt(String(patient.opd_age_month || '').trim(), 10) || 0;
    const d = parseInt(String(patient.opd_age_day || '').trim(), 10) || 0;
  
    if (y === 0 && m === 0 && d === 0) return 'N/A';
  
    const parts = [];
    if (y > 0) parts.push(`${y} Yr${y > 1 ? 's' : ''}`);
    if (m > 0) parts.push(`${m} M`);
    if (d > 0) parts.push(`${d} D`);
    return parts.join(' ');
  };

  // ── PROCEDURE BILL PDF (document-5 style, auto-print) ──
  const generateProcedurePDF = async () => {
    if (procItems.length === 0) { toast.error('No items to print'); return; }
    const doc = new jsPDF('p', 'pt', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    let y = 0;
    try {
      if (headerLogo) {
        const b64 = await imageUrlToBase64(headerLogo);
        if (b64) { doc.addImage(b64, 'PNG', 0, 0, pageWidth, 80); y = 105; } else y = 40;
      } else y = 40;
    } catch (e) { y = 40; }

    doc.setFontSize(16).setFont('helvetica', 'bold');
    doc.text('PROCEDURE BILL', pageWidth / 2, y, { align: 'center' });
    y += 30;

    const leftX = 30, rightX = 330, labelOffset = 110;
    const addInfoLine = (l1, v1, l2, v2) => {
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold').text(l1, leftX, y);
      doc.setFont('helvetica', 'normal').text(`: ${v1 ?? ''}`, leftX + labelOffset, y);
      if (l2) {
        doc.setFont('helvetica', 'bold').text(l2, rightX, y);
        doc.setFont('helvetica', 'normal').text(`: ${v2 ?? ''}`, rightX + labelOffset, y);
      }
      y += 18;
    };

    addInfoLine('Bill No', `PRO-${procBillId || 'NEW'}`, 'Bill Date', formatDateDisplay(new Date()));
    addInfoLine('UHID', patient.opd_uhid, 'OPD No', `000${patient.opd_id}`);
    addInfoLine('Patient Name', `${patient.opd_patient_title} ${patient.opd_patient_name}`.trim(), 'Age/Gender', `${getAgeDisplay()}/${patient.opd_patient_gender}`);
    addInfoLine('Phone', patient.opd_patient_mobile, 'Address', patient.opd_address);
    y += 10;

    const tableData = procItems.map((item, i) => [
      i + 1, item.service_name, item.qty,
      Number(item.unit_price).toFixed(2), Number(item.discount).toFixed(2), Number(item.final_price).toFixed(2),
    ]);
    autoTable(doc, {
      startY: y,
      head: [['S.No', 'Procedure', 'Qty', 'Unit Price', 'Discount', 'Amount']],
      body: tableData, theme: 'grid',
      headStyles: { fillColor: [180, 220, 250], textColor: 0, fontStyle: 'bold' },
      styles: { fontSize: 10, cellPadding: 4 },
      columnStyles: {
        0: { halign: 'center', cellWidth: 40 }, 2: { halign: 'center', cellWidth: 40 },
        3: { halign: 'right', cellWidth: 80 }, 4: { halign: 'right', cellWidth: 70 }, 5: { halign: 'right', cellWidth: 80 },
      },
    });
    y = doc.lastAutoTable.finalY + 20;

    const rightAlign = pageWidth - 30, labelX = pageWidth - 180;
    doc.setFontSize(10).setFont('helvetica', 'bold');
    doc.text('Total Amount:', labelX, y); doc.text(`${procTotals.total}`, rightAlign, y, { align: 'right' }); y += 18;
    doc.text(`Discount (${procTotals.discount_percent}%):`, labelX, y); doc.text(`${procTotals.discount_amount}`, rightAlign, y, { align: 'right' }); y += 18;
    const subTotal = parseFloat(procTotals.total) - parseFloat(procTotals.discount_amount);
    doc.text('Sub Total:', labelX, y); doc.text(`${subTotal.toFixed(2)}`, rightAlign, y, { align: 'right' }); y += 18;
    const paidAmount = parseFloat(procTotals.paid_amount || 0);
    if (paidAmount > 0) { doc.text('Paid Amount:', labelX, y); doc.text(`${paidAmount.toFixed(2)}`, rightAlign, y, { align: 'right' }); y += 18; }
    doc.setFontSize(12).setFont('helvetica', 'bold');
    doc.text('Balance Due:', labelX, y); doc.text(`${procTotals.final_amount}`, rightAlign, y, { align: 'right' }); y += 25;

    let payments = procPayments;
    if ((!payments || payments.length === 0) && procBillId && AppConst.getProcedureBillPaymentsUrl) {
      try {
        const fd = new FormData();
        fd.append('procedure_bill_id', procBillId);
        const res = await axios.post(
          AppConst.BASE_URL + AppConst.getProcedureBillPaymentsUrl, fd,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        if (res?.data?.status) payments = res.data.payments || [];
      } catch (e) { }
    }
    if (payments && payments.length > 0) {
      y += 10;
      doc.setFontSize(11).setFont('helvetica', 'bold');
      doc.text('Payment Transactions', 30, y); y += 20;
      const payRows = payments.map((p, i) => [
        i + 1, `${Number(p.amount || 0).toFixed(2)}`, p.payment_mode || 'Cash',
        p.received_by_name || p.received_by || 'Unknown',
        p.payment_date ? formatDateDisplay(p.payment_date) : (p.created_at ? formatDateDisplay(p.created_at) : ''),
      ]);
      autoTable(doc, {
        startY: y,
        head: [['S.No', 'Amount', 'Mode of Payment', 'Received By', 'Date']],
        body: payRows, theme: 'grid',
        headStyles: { fillColor: [180, 220, 250], textColor: 0, fontStyle: 'bold' },
        styles: { fontSize: 10, cellPadding: 4 },
        columnStyles: {
          0: { halign: 'center', cellWidth: 40 }, 1: { halign: 'right', cellWidth: 80 },
          2: { halign: 'center', cellWidth: 90 }, 3: { halign: 'left' }, 4: { halign: 'left', cellWidth: 90 },
        },
      });
      y = doc.lastAutoTable.finalY + 20;
    } else {
      y += 10;
      doc.setFontSize(9).setFont('helvetica', 'italic');
      doc.text('No payment transactions recorded', 30, y); y += 20;
    }

    doc.setFontSize(9).setFont('helvetica', 'normal');
    doc.text(`Prepared By: ${Name || 'User'}`, 30, y);
    doc.text('Authorized Signature', pageWidth - 30, pageHeight - 30, { align: 'right' });

    const pdfBlob = doc.output('blob');
    const url = URL.createObjectURL(pdfBlob);
    const w = window.open(url, '_blank');
    if (w) w.onload = () => w.print();
  };

  // ── INVESTIGATION PDF (Lab receipt style, auto-print) ──
  const generateInvestigationPDF = async (headerOption, includeLabCopy, includeRadiologyCopy, printLayout) => {
    if (selectedTests.length === 0) { toast.error('No tests to print'); return; }
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const HALF = pageHeight / 2;
    const rawRef = labReferralName || patient.opd_concult_doctor || '';
    // if the stored referral is a numeric id, look up the name; else use as-is
    const referralDisplay = /^\d+$/.test(String(rawRef).trim())
      ? (getDoctorNameById(rawRef) || String(rawRef))
      : rawRef;
    const regDateStr = formatDateTimeDisplay(labRegDatetime || new Date());
    const drawPatientDetails = (startY) => {
      autoTable(doc, {
        startY,
        body: [[
          `UHID No : ${patient.opd_uhid || ''}\n` +
          `Reg No : 00${labRegId || ''}\n` +
          `Patient Name: ${patient.opd_patient_title || ''} ${patient.opd_patient_name || ''}\n` +
      `Registered Date : ${regDateStr}`,
          `Address : ${patient.opd_address || ''}\n` +
          `Mobile No : ${patient.opd_patient_mobile || ''}`,
         `Age : ${getAgeDisplay()}\n` +
`Gender : ${patient.opd_patient_gender || ''}\n` +
`Referred Doctor : ${referralDisplay}`
        ]],
        theme: 'grid',
        styles: { fontSize: 7.5, cellPadding: 1.5, valign: 'top', textColor: [0, 0, 0], lineColor: [0, 0, 0], lineWidth: 0.1 },
        margin: { left: 10, right: 10 }, tableWidth: 'auto',
        columnStyles: { 0: { cellWidth: 60 }, 1: { cellWidth: 60 }, 2: { cellWidth: 70 } }
      });
      return doc.lastAutoTable.finalY;
    };

    const drawSingleReceipt = async (startY, copyLabel, headerImageBase64) => {
      let y = startY;
      if (headerImageBase64) { doc.addImage(headerImageBase64, 0, y, pageWidth, 22); y += 23; } else y += 4;
      if (copyLabel) {
        doc.setFontSize(8).setFont('helvetica', 'bold').setTextColor(120, 120, 120);
        doc.text(copyLabel, pageWidth - 12, y, { align: 'right' });
        doc.setTextColor(0, 0, 0);
      }
      y = drawPatientDetails(y) + 1;
      const testData = selectedTests.map((t, i) => [
        i + 1, t.test_name || 'N/A',
        parseFloat(t.test_price || 0).toFixed(2),
        parseFloat(t.lab_item_total || t.test_price || 0).toFixed(2)
      ]);
      autoTable(doc, {
        startY: y,
        head: [['Sl.', 'Test Name', 'Amount', 'Final']],
        body: testData.length ? testData : [['1', 'N/A', '0.00', '0.00']],
        theme: 'grid',
        headStyles: { fillColor: [255, 255, 255], textColor: 0, fontStyle: 'bold', fontSize: 7.5 },
        bodyStyles: { fontSize: 7.5, textColor: 0 },
        styles: { cellPadding: 1, lineWidth: 0.1, lineColor: [0, 0, 0] },
        margin: { left: 10, right: 10 },
        columnStyles: { 0: { cellWidth: 14, halign: 'center' }, 1: { cellWidth: 116 }, 2: { cellWidth: 30, halign: 'right' }, 3: { cellWidth: 30, halign: 'right' } }
      });
      y = doc.lastAutoTable.finalY + 3;
      const labelX = 140, valueX = 195, gap = 4;
      const totalAmt = parseFloat(labTotals.total || 0);
      const discountPct = parseFloat(labTotals.discount_percent || 0);
      const discountAmt = parseFloat(labTotals.discount_fixed || 0);
      const finalAmt = parseFloat(labTotals.final_amount || 0);
      const paidAmt = parseFloat(labTotals.paid || 0);
      const dueAmt = parseFloat(labTotals.due ?? (finalAmt - paidAmt) ?? 0);
      doc.setFont('helvetica', 'bold').setFontSize(7.5);
      const printLine = (label, value, offset) => {
        doc.text(label, labelX, y + offset);
        doc.text(parseFloat(value || 0).toFixed(2), valueX, y + offset, null, null, 'right');
      };
      printLine('Total', totalAmt, 0);
      printLine('Disc(%)', discountPct, gap);
      printLine('Disc Amt', discountAmt, gap * 2);
      printLine('Final', finalAmt, gap * 3);
      printLine('Paid', paidAmt, gap * 4);
      printLine('Due', dueAmt, gap * 5);
      const wordsY = y + gap * 5 + 4;
      doc.setFontSize(7).setFont('helvetica', 'bold');
      doc.text(`IN WORDS: ${amountInWords(labTotals.final_amount)} only`.toUpperCase(), 10, wordsY);
      y = wordsY + 3;
      if (Array.isArray(labPayments) && labPayments.length > 0) {
        doc.setFontSize(7.5).setFont('helvetica', 'bold');
        doc.text('Payment History', 10, y + 1); y += 2.5;
        const payRows = labPayments.map((p, i) => [
          i + 1,
          p.payment_datetime ? new Date(p.payment_datetime).toLocaleString() : '',
          parseFloat(p.payment_amount || 0).toFixed(2),
          p.payment_mode || '',
          p.payment_received_by || ''
        ]);
        autoTable(doc, {
          startY: y,
          head: [['#', 'Date & Time', 'Amount', 'Mode', 'Received By']],
          body: payRows, theme: 'grid',
          headStyles: { fillColor: [255, 255, 255], textColor: 0, fontStyle: 'bold', fontSize: 6.5 },
          bodyStyles: { fontSize: 6.5, textColor: 0 },
          styles: { cellPadding: 0.8, lineWidth: 0.1, lineColor: [0, 0, 0] },
          margin: { left: 10, right: 10 },
          columnStyles: { 0: { cellWidth: 8, halign: 'center' }, 1: { cellWidth: 55 }, 2: { cellWidth: 28, halign: 'right' }, 3: { cellWidth: 24 }, 4: { cellWidth: 75 } }
        });
        y = doc.lastAutoTable.finalY + 3;
      }
      const qrText = `UHID: ${patient.opd_uhid || 'N/A'}\nName: ${patient.opd_patient_name || 'N/A'}`;
      try {
        const qr = await QRCode.toDataURL(qrText, { width: 80 });
        doc.addImage(qr, 'PNG', 10, y, 14, 14);
      } catch (e) { }
      doc.setFontSize(7).setFont('helvetica', 'normal');
      doc.text(`Prepared By: ${Name || 'User'}`, 28, y + 8);
      doc.text('Authorized Signature', pageWidth - 50, y + 8);
      return y + 16;
    };

    let headerImageBase64 = null;
    if (headerOption === 'with') { try { headerImageBase64 = await imageUrlToBase64(headerLogo); } catch (_) {} }

    if (headerOption === 'with') {
      if (printLayout === 'separate') {
        await drawSingleReceipt(0, 'PATIENT COPY', headerImageBase64);
      } else {
        await drawSingleReceipt(0, 'PATIENT COPY', headerImageBase64);
        doc.setLineDashPattern([2, 2], 0); doc.setDrawColor(120, 120, 120);
        doc.line(8, HALF, pageWidth - 8, HALF);
        doc.setFontSize(6).setTextColor(120, 120, 120);
        doc.text('Cut here', pageWidth / 2, HALF - 0.5, { align: 'center' });
        doc.setLineDashPattern([], 0); doc.setDrawColor(0, 0, 0); doc.setTextColor(0, 0, 0);
        await drawSingleReceipt(HALF + 2, 'OFFICE COPY', headerImageBase64);
      }
    } else {
      await drawSingleReceipt(0, '', null);
    }

    const radiologyCategories = [
      { key: 'xray', title: 'X-RAY COPY', keywords: ['x-ray', 'xray', 'x ray'] },
      { key: 'ct', title: 'CT SCAN COPY', keywords: ['ct scan', 'ct-scan', 'ctscan', 'ct '] },
      { key: 'mri', title: 'MRI COPY', keywords: ['mri'] },
      { key: 'usg', title: 'ULTRASOUND / USG COPY', keywords: ['ultrasound', 'usg', 'sonography', 'sono'] },
      { key: 'ecg', title: 'ECG COPY', keywords: ['ecg', 'electrocardiogram'] },
      { key: 'echo', title: 'ECHO COPY', keywords: ['echo', 'echocardiography', 'echocardiogram'] },
      { key: 'eeg', title: 'EEG COPY', keywords: ['eeg', 'electroencephalogram'] },
      { key: 'emg', title: 'EMG COPY', keywords: ['emg', 'electromyography'] },
      { key: 'mammography', title: 'MAMMOGRAPHY COPY', keywords: ['mammography', 'mammogram'] },
      { key: 'fluoroscopy', title: 'FLUOROSCOPY COPY', keywords: ['fluoroscopy'] },
      { key: 'dexa', title: 'DEXA SCAN COPY', keywords: ['dexa', 'bone density'] },
      { key: 'pet', title: 'PET SCAN COPY', keywords: ['pet scan', 'pet-scan'] },
    ];
    const isRadiologyTest = (n) => {
      const name = String(n || '').toLowerCase();
      return radiologyCategories.some(c => c.keywords.some(kw => name.includes(kw)));
    };
    const getRadiologyCategory = (n) => {
      const name = String(n || '').toLowerCase();
      for (const c of radiologyCategories) if (c.keywords.some(kw => name.includes(kw))) return c.key;
      return null;
    };
    const allTests = selectedTests || [];
    const labTests = allTests.filter(t => !isRadiologyTest(t.test_name || ''));
    const radiologyGroups = {};
    allTests.forEach(t => {
      const catKey = getRadiologyCategory(t.test_name || '');
      if (catKey) { if (!radiologyGroups[catKey]) radiologyGroups[catKey] = []; radiologyGroups[catKey].push(t); }
    });
    const drawCopyPage = async (title, tests) => {
      if (!tests || tests.length === 0) return;
      doc.addPage();
      let copyY = 0;
      if (headerImageBase64) { doc.addImage(headerImageBase64, 0, 0, pageWidth, 26); copyY = 29; } else copyY = 6;
      doc.setFontSize(12).setFont('helvetica', 'bold');
      doc.text(title, pageWidth / 2, copyY + 4, { align: 'center' });
      copyY += 10;
      copyY = drawPatientDetails(copyY) + 1;
      const tableData = tests.map((t, i) => [i + 1, t.test_name || 'N/A']);
      autoTable(doc, {
        startY: copyY,
        head: [['Sl. No', 'Test Name']],
        body: tableData, theme: 'grid',
        headStyles: { fillColor: [240, 240, 240], textColor: 0, fontStyle: 'bold', fontSize: 9 },
        bodyStyles: { fontSize: 9, textColor: 0 },
        styles: { cellPadding: 3, lineWidth: 0.1, lineColor: [0, 0, 0] },
        margin: { left: 10, right: 10 },
        columnStyles: { 0: { cellWidth: 25, halign: 'center' }, 1: { cellWidth: 165 } }
      });
      copyY = doc.lastAutoTable.finalY + 10;
      doc.setFontSize(8).setFont('helvetica', 'normal');
      doc.text(`Prepared By: ${Name || 'User'}`, 10, copyY + 10);
      doc.text('Authorized Signature', 160, copyY + 10);
    };
    if (headerOption === 'with') {
      if (includeLabCopy && labTests.length > 0) await drawCopyPage('LAB COPY', labTests);
      if (includeRadiologyCopy) {
        for (const cat of radiologyCategories) {
          const tests = radiologyGroups[cat.key];
          if (tests && tests.length > 0) await drawCopyPage(cat.title, tests);
        }
      }
    }

    const pdfBlob = doc.output('blob');
    const url = URL.createObjectURL(pdfBlob);
    const w = window.open(url, '_blank');
    if (w) w.onload = () => w.print();
  };

  const renderVisitBadges = (p) => {
    const labV = p.lab_visit_count ?? 0;
    const ipdV = p.ipd_visit_count ?? 0;
    const opdV = p.opd_visit_count ?? 0;
    const pharmaV = p.pharma_visit_count ?? 0;
    return (
      <div className="d-flex gap-1 flex-wrap">
        {labV > 0 && <span className="badge" style={{ background: '#cff4fc', color: '#055160', fontSize: 9 }}>🧪{labV}x</span>}
        {ipdV > 0 && <span className="badge" style={{ background: '#cfe2ff', color: '#084298', fontSize: 9 }}>🏥{ipdV}x</span>}
        {opdV > 0 && <span className="badge" style={{ background: '#d1e7dd', color: '#0f5132', fontSize: 9 }}>🩺{opdV}x</span>}
        {pharmaV > 0 && <span className="badge" style={{ background: '#fff3cd', color: '#664d03', fontSize: 9 }}>💊{pharmaV}x</span>}
        {(labV + ipdV + opdV + pharmaV) === 0 && <span className="badge bg-secondary" style={{ fontSize: 9 }}>New</span>}
      </div>
    );
  };

  // ══════════════════════════════════════
  //  RENDER
  // ══════════════════════════════════════
  return (
    <div className="page-content" style={{ paddingTop: 10 }}>
      <div className="container-fluid">

        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-flex align-items-center justify-content-between">
              <h4 className="mb-0"><i className="ri-bill-line me-2"></i>OP Billing</h4>
            </div>
          </div>
        </div>

        {/* PATIENT SEARCH CARD */}
        <div className="card">
          <div className="card-body">
            <div className="row align-items-end">
              <div className="col-lg-12 mb-2">
                <h5 style={{ color: '#405189' }}><i className="ri-user-search-line me-2"></i>Patient Search</h5>
              </div>
              <div className="col-md-4">
                <div className="mb-3 position-relative">
                  <label className="form-label">Search Patient
                    <small className="text-muted ms-2" style={{ fontSize: 11, fontWeight: 400 }}>(UHID / Phone / Name)</small>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="ri-search-line"></i></span>
                    <input type="text" className="form-control" placeholder="Type UHID, 10-digit phone, or name..."
                      value={searchInput} autoComplete="off" onChange={(e) => handleSearchInput(e.target.value)} />
                    {searchLoading && (<span className="input-group-text"><span className="spinner-border spinner-border-sm"></span></span>)}
                    {patientLoaded && (<button className="btn btn-outline-danger" type="button" onClick={clearPatient}><i className="ri-close-line"></i></button>)}
                  </div>
                  <small className="text-muted" style={{ fontSize: 10 }}>💡 Phone (10 digits) searches instantly. UHID/Name needs 3+ characters.</small>

                  {uhidSuggestions.length > 0 && (
                    <ul style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 1050, maxHeight: 300, overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: 4, boxShadow: '0 4px 12px rgba(0,0,0,0.15)', margin: '4px 0 0 0', padding: 0, listStyle: 'none', background: '#fff' }}>
                      <li style={{ padding: '6px 12px', background: '#f8f9fa', borderBottom: '1px solid #dee2e6', fontSize: 11, color: '#405189', fontWeight: 600 }}>
                        {uhidSuggestions.length} match{uhidSuggestions.length !== 1 ? 'es' : ''} found — click to select
                      </li>
                      {uhidSuggestions.map((p, idx) => (
                        <li key={idx} onClick={() => selectPatient(p)}
                          style={{ cursor: 'pointer', fontSize: 12, padding: '10px 12px', borderBottom: '1px solid #f0f0f0', transition: 'background .1s' }}
                          onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
                          onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                          <div className="d-flex justify-content-between align-items-start">
                            <div style={{ flex: 1 }}>
                              <div><strong style={{ color: '#405189' }}>{p.lab_reg_name_title || p.opd_patient_title} {p.lab_reg_name || p.opd_patient_name || p.patient_name}</strong></div>
                              <div className="text-muted mt-1" style={{ fontSize: 11 }}>
                                <span className="me-2"><i className="ri-fingerprint-line me-1" /><strong>{p.lab_reg_uhid || p.opd_uhid || p.uhid}</strong></span>
                                <span className="me-2"><i className="ri-phone-line me-1" />{p.lab_reg_mobile || p.opd_patient_mobile || p.mobile}</span>
                                <span className="me-2">{p.lab_reg_age_year ? p.lab_reg_age_year + 'Y' : ''} / {p.lab_reg_gender || p.opd_patient_gender}</span>
                              </div>
                            </div>
                            <div className="ms-2 flex-shrink-0" style={{ maxWidth: 120 }}>{renderVisitBadges(p)}</div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  )}

                  {noPatientFound && !patientLoaded && !searchLoading && uhidSuggestions.length === 0 && searchInput.trim().length >= 2 && (
                    <div className="alert alert-warning d-flex align-items-center mt-2 mb-0 py-2" role="alert">
                      <i className="ri-error-warning-line me-2 fs-5"></i>
                      <div>No patient found for "<strong>{searchInput}</strong>". Please check the UHID, phone number, or name.</div>
                    </div>
                  )}
                </div>
              </div>

              {patientLoaded && (
                <>
                  <div className="col-md-2"><div className="mb-3"><label className="form-label">UHID</label>
                    <input type="text" className="form-control" value={patient.opd_uhid} readOnly style={{ backgroundColor: '#e8f5e9', fontWeight: 600 }} /></div></div>
                  <div className="col-md-2"><div className="mb-3"><label className="form-label">Patient Name</label>
                    <input type="text" className="form-control" value={`${patient.opd_patient_title} ${patient.opd_patient_name}`.trim()} readOnly style={{ backgroundColor: '#e9ecef' }} /></div></div>
                  <div className="col-md-1"><div className="mb-3"><label className="form-label">Age</label>
                    <input type="text" className="form-control" value={patient.opd_guardien_age || 'N/A'} readOnly style={{ backgroundColor: '#e9ecef' }} /></div></div>
                  <div className="col-md-1"><div className="mb-3"><label className="form-label">Gender</label>
                    <input type="text" className="form-control" value={patient.opd_patient_gender || 'N/A'} readOnly style={{ backgroundColor: '#e9ecef' }} /></div></div>
                </>
              )}
            </div>

            {patientLoaded && (
              <div className="row">
                <div className="col-md-3"><div className="mb-2"><label className="form-label">Mobile</label>
                  <input type="text" className="form-control form-control-sm" value={patient.opd_patient_mobile || 'N/A'} readOnly style={{ backgroundColor: '#e9ecef' }} /></div></div>
                <div className="col-md-5"><div className="mb-2"><label className="form-label">Address</label>
                  <input type="text" className="form-control form-control-sm" value={patient.opd_address || 'N/A'} readOnly style={{ backgroundColor: '#e9ecef' }} /></div></div>
                <div className="col-md-2"><div className="mb-2"><label className="form-label">City</label>
                  <input type="text" className="form-control form-control-sm" value={patient.opd_city || 'N/A'} readOnly style={{ backgroundColor: '#e9ecef' }} /></div></div>
              </div>
            )}
          </div>
        </div>

        {/* TAB NAVIGATION */}
        {patientLoaded && (
          <>
            <ul className="nav nav-tabs nav-tabs-custom nav-justified mb-3" role="tablist">
              <li className="nav-item" role="presentation">
                <button className={`nav-link ${activeTab === 'procedure' ? 'active' : ''}`} onClick={() => setActiveTab('procedure')} type="button">
                  <i className="ri-surgical-mask-line me-1"></i>Procedure Bill
                  {procItems.length > 0 && <span className="badge bg-primary ms-2">{procItems.length}</span>}
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button className={`nav-link ${activeTab === 'investigation' ? 'active' : ''}`} onClick={() => setActiveTab('investigation')} type="button">
                  <i className="ri-test-tube-line me-1"></i>Investigation
                  {selectedTests.length > 0 && <span className="badge bg-success ms-2">{selectedTests.length}</span>}
                </button>
              </li>
            </ul>

            {/* PROCEDURE BILL TAB */}
            {activeTab === 'procedure' && (
              <div className="card">
                <div className="card-body">
                  <h5 style={{ color: '#405189' }}>
                    <i className="ri-surgical-mask-line me-2"></i>Procedure / Service Bill
                    {procBillLoaded && <span className="badge bg-info ms-2" style={{ fontSize: 11 }}>Bill #{procBillId}</span>}
                  </h5>
                  <hr />
                  <div className="row mb-3">
                    <div className="col-md-8">
                      <label className="form-label">Search & Add Service / Procedure</label>
                      <Select options={serviceOptions} isLoading={isLoadingServices} onChange={handleServiceSelect}
                        onInputChange={(val) => { if (val.length >= 1) fetchServices(val); }}
                        placeholder="Type to search services..." isClearable value={null}
                        noOptionsMessage={() => 'No services found'}
                        styles={{ control: (b) => ({ ...b, minHeight: 42 }), menu: (b) => ({ ...b, zIndex: 1050 }) }} />
                    </div>
                  </div>

                  {procItems.length > 0 && (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped align-middle">
                        <thead className="table-light"><tr>
                          <th style={{ width: 60 }}>S.No</th><th>Service Name</th><th style={{ width: 80 }}>Qty</th>
                          <th style={{ width: 120 }}>Unit Price</th><th style={{ width: 120 }}>Discount</th>
                          <th style={{ width: 120 }}>Total</th><th style={{ width: 70 }}>Action</th>
                        </tr></thead>
                        <tbody>
                          {procItems.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td><strong>{item.service_name}</strong></td>
                              <td><input type="number" className="form-control form-control-sm" value={item.qty} min="1" onChange={(e) => handleProcItemChange(index, 'qty', e.target.value)} /></td>
                              <td><input type="number" className="form-control form-control-sm" value={item.unit_price} onChange={(e) => handleProcItemChange(index, 'unit_price', e.target.value)} /></td>
                              <td><input type="number" className="form-control form-control-sm" value={item.discount} min="0" onChange={(e) => handleProcItemChange(index, 'discount', e.target.value)} /></td>
                              <td className="fw-bold">₹{Number(item.final_price).toFixed(2)}</td>
                              <td className="text-center"><button type="button" className="btn btn-danger btn-sm" onClick={() => removeProcItem(index)}><i className="ri-delete-bin-5-fill"></i></button></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}

                  {procItems.length > 0 && (
                    <div className="row mt-3">
                      <div className="col-md-3"><label className="form-label">Total Amount</label>
                        <input type="text" className="form-control" value={`₹${procTotals.total}`} readOnly style={{ backgroundColor: '#e9ecef', fontWeight: 600 }} /></div>
                      <div className="col-md-2"><label className="form-label">Discount (%)</label>
                        <input type="number" className="form-control" value={procTotals.discount_percent} min="0" max="100"
                          onChange={(e) => { const pct = e.target.value; setProcTotals(prev => ({ ...prev, discount_percent: pct })); recalcProcTotals(procItems, pct); }} /></div>
                      <div className="col-md-2"><label className="form-label">Discount (₹)</label>
                        <input type="number" className="form-control" value={procTotals.discount_amount} min="0" onChange={(e) => recalcProcTotals(procItems, 0, Number(e.target.value))} /></div>
                      <div className="col-md-2"><label className="form-label">Paid</label>
                        <input type="text" className="form-control" value={`₹${procTotals.paid_amount}`} readOnly style={{ backgroundColor: '#e9ecef' }} /></div>
                      <div className="col-md-3"><label className="form-label">Due / Balance</label>
                        <div className="input-group">
                          <input type="text" className="form-control fw-bold" value={`₹${procTotals.final_amount}`} readOnly
                            style={{ backgroundColor: parseFloat(procTotals.final_amount) > 0 ? '#fff3cd' : '#d1e7dd', fontWeight: 700 }} />
                          {parseFloat(procTotals.final_amount) > 0 && procBillId && (
                            <button className="btn btn-success" type="button" onClick={handleProcPayment}><i className="ri-money-dollar-circle-line me-1"></i>Pay</button>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {procPayments.length > 0 && (
                    <div className="mt-4">
                      <h6 style={{ color: '#405189' }}>Payment History</h6>
                      <div className="table-responsive">
                        <table className="table table-sm table-bordered">
                          <thead className="table-light"><tr><th>#</th><th>Date</th><th>Mode</th><th>Amount</th><th>Received By</th></tr></thead>
                          <tbody>
                            {procPayments.map((p, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{new Date(p.payment_date || p.created_at).toLocaleString()}</td>
                                <td><span className={`badge ${p.payment_mode === 'Cash' ? 'bg-success' : 'bg-primary'}`}>{p.payment_mode}</span></td>
                                <td className="fw-bold">₹{parseFloat(p.amount || 0).toFixed(2)}</td>
                                <td>{p.received_by_name || p.received_by || '-'}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  <div className="text-end mt-3">
                    <button type="button" className="btn btn-primary" onClick={saveProcedureBill} disabled={procSaving || procItems.length === 0}>
                      <i className="ri-save-line me-1"></i>{procBillId ? 'Update Bill' : 'Save Bill'}
                    </button>
                    &nbsp;
                    <button type="button" className="btn btn-dark" onClick={generateProcedurePDF} disabled={!procBillId || procItems.length === 0}>
                      <i className="ri-printer-line me-1"></i>Print Bill
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* INVESTIGATION TAB */}
            {activeTab === 'investigation' && (
              <div className="card">
                <div className="card-body">
                  <h5 style={{ color: '#405189' }}>
                    <i className="ri-test-tube-line me-2"></i>Investigation (Lab Tests)
                    {labRegLoaded && <span className="badge bg-info ms-2" style={{ fontSize: 11 }}>Reg #{labRegId}</span>}
                  </h5>
                  <hr />
                  <div className="row mb-3">
                    <div className="col-md-8 position-relative">
                      <label className="form-label">Search & Add Test</label>
                      <input ref={testInputRef} type="text" className="form-control" placeholder="Type test name to search..."
                        value={testSearchKey} onChange={(e) => handleTestSearch(e.target.value)}
                        onFocus={() => { setShowTestDropdown(true); if (!testSearchKey) { fetchTests(''); setTestPage(0); } }}
                        onBlur={() => setTimeout(() => setShowTestDropdown(false), 200)} />
                      {showTestDropdown && (
                        <div className="dropdown-menu show w-100" style={{ maxHeight: 400, overflowY: 'auto', position: 'absolute', zIndex: 1050, boxShadow: '0 4px 16px rgba(0,0,0,0.12)' }}>
                          {isTestLoading ? (
                            <div className="text-center p-2"><span className="spinner-border spinner-border-sm me-2"></span>Searching...</div>
                          ) : searchResults.length === 0 ? (
                            <div className="p-2 text-muted text-center">No tests found</div>
                        ) : (() => {
                            const totalPages = Math.ceil(searchResults.length / TESTS_PER_PAGE);
                            const startIdx = testPage * TESTS_PER_PAGE;
                            const pageItems = searchResults.slice(startIdx, startIdx + TESTS_PER_PAGE);
                            return (
                                <>
                                  {/* ── count header ── */}
                                  <div style={{ padding: '6px 12px', background: '#f8f9fa', borderBottom: '1px solid #dee2e6', fontSize: 12, color: '#405189', fontWeight: 600, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <span style={{ fontSize: 11, color: '#6c757d' }}>
  {startIdx + 1}–{Math.min(startIdx + TESTS_PER_PAGE, searchResults.length)} of {searchResults.length}
</span>
                                    {totalPages > 1 && <span style={{ color: '#6c757d', fontSize: 11 }}>Page {testPage + 1} of {totalPages}</span>}
                                  </div>
                            
                                  {/* ── test items ── */}
                                  {pageItems.map((test, idx) => (
                                    <div key={idx} className="dropdown-item"
                                      onMouseDown={(e) => { e.preventDefault(); addTest(test); setShowTestDropdown(true); setTimeout(() => testInputRef.current?.focus(), 50); }}
                                      style={{ cursor: 'pointer', padding: '8px 12px', borderBottom: '1px solid #f0f0f0', transition: 'background .1s' }}
                                      onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
                                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                          <strong style={{ fontSize: 13 }}>{test.test_name}</strong>
                                          <div className="text-muted" style={{ fontSize: 11 }}>{test.cat_name}</div>
                                        </div>
                                        <span style={{ fontWeight: 600, color: '#198754', fontSize: 13, whiteSpace: 'nowrap', marginLeft: 8 }}>₹{test.test_price}</span>
                                      </div>
                                    </div>
                                  ))}
                            
                                  {/* ── pagination footer ── */}
                                  {totalPages > 1 && (
                                    <div style={{ padding: '6px 10px', background: '#f8f9fa', borderTop: '1px solid #dee2e6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                      <button type="button" className="btn btn-sm btn-outline-primary" disabled={testPage === 0}
                                        onMouseDown={e => { e.preventDefault(); setTestPage(p => Math.max(0, p - 1)); }} style={{ minWidth: 70, fontSize: 12 }}>
                                        <i className="ri-arrow-left-s-line" /> Prev</button>
                                        <span style={{ fontSize: 11, color: '#6c757d' }}>
  {startIdx + 1}–{Math.min(startIdx + TESTS_PER_PAGE, searchResults.length)} of {searchResults.length}
</span>
                                      <button type="button" className="btn btn-sm btn-outline-primary" disabled={testPage >= totalPages - 1}
                                        onMouseDown={e => { e.preventDefault(); setTestPage(p => Math.min(totalPages - 1, p + 1)); }} style={{ minWidth: 70, fontSize: 12 }}>
                                        Next <i className="ri-arrow-right-s-line" /></button>
                                    </div>
                                  )}
                                </>
                              );
                            })()}
                        </div>
                      )}
                    </div>
                  </div>

                  {selectedTests.length > 0 && (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped align-middle">
                        <thead className="table-light"><tr>
                          <th style={{ width: 60 }}>S.No</th><th>Test Name</th><th>Category</th>
                          <th style={{ width: 120 }}>Price</th><th style={{ width: 120 }}>Discount</th>
                          <th style={{ width: 120 }}>Total</th><th style={{ width: 70 }}>Action</th>
                        </tr></thead>
                        <tbody>
                        {selectedTests.map((test, index) => (
 <tr key={test.row_uid || `${test.test_id || 'noid'}-${index}`}>
                              <td>{index + 1}</td>
                              <td><strong>{test.test_name}</strong></td>
                              <td><span className="text-muted">{test.cat_name || '-'}</span></td>
                              <td>₹{Number(test.test_price).toFixed(2)}</td>
                              <td><input type="number" className="form-control form-control-sm" value={test.test_discount} min="0" onChange={(e) => handleTestDiscountChange(index, e.target.value)} /></td>
                              <td className="fw-bold">₹{Number(test.lab_item_total).toFixed(2)}</td>
                              <td className="text-center"><button type="button" className="btn btn-danger btn-sm" onClick={() => removeTest(index)}><i className="ri-delete-bin-5-fill"></i></button></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}

                  {selectedTests.length > 0 && (
                    <div className="row mt-3">
                      <div className="col-md-2"><label className="form-label">Total</label>
                        <input type="text" className="form-control" value={`₹${labTotals.total}`} readOnly style={{ backgroundColor: '#e9ecef', fontWeight: 600 }} /></div>
                      <div className="col-md-2"><label className="form-label">Discount (%)</label>
                        <input type="number" className="form-control" value={labTotals.discount_percent} min="0" max="100"
                          onChange={(e) => { const pct = e.target.value; setLabTotals(prev => ({ ...prev, discount_percent: pct })); recalcLabTotals(selectedTests, Number(pct), null); }} /></div>
                      <div className="col-md-2"><label className="form-label">Fixed Discount</label>
                        <input type="number" className="form-control" value={labTotals.discount_fixed} min="0"
                          onChange={(e) => { const val = e.target.value; setLabTotals(prev => ({ ...prev, discount_fixed: val })); recalcLabTotals(selectedTests, null, Number(val)); }} /></div>
                      <div className="col-md-2"><label className="form-label">Final Amount</label>
                        <input type="text" className="form-control" value={`₹${labTotals.final_amount}`} readOnly style={{ backgroundColor: '#e9ecef', fontWeight: 600 }} /></div>
                      <div className="col-md-2"><label className="form-label">Paid</label>
                        <input type="number" className="form-control" value={labTotals.paid} readOnly style={{ backgroundColor: '#e9ecef' }} /></div>
                        <div className="col-md-2"><label className="form-label">Due</label>
  <div className="input-group">
    <input type="text" className="form-control fw-bold" value={`₹${labTotals.due}`} readOnly
      style={{ backgroundColor: parseFloat(labTotals.due) > 0 ? '#fff3cd' : '#d1e7dd', fontWeight: 700 }} />
    {labRegId && parseFloat(labTotals.due || 0) > 0 && (
      <button className="btn btn-success" type="button" onClick={handleLabPayClick}>
        <i className="ri-money-dollar-circle-line"></i>
      </button>
    )}
  </div>
</div>
                    </div>
                  )}

                  {selectedTests.length > 0 && (
                    <div className="row mt-3">
                      <div className="col-md-3"><label className="form-label">Payment Mode</label>
                        <select className="form-control" value={labTotals.pay_mode} onChange={(e) => setLabTotals(prev => ({ ...prev, pay_mode: e.target.value }))}>
                          <option value="Cash">Cash</option><option value="Online">Online</option><option value="Card">Card</option>
                        </select>
                      </div>
                      <div className="col-md-9 text-end" style={{ alignSelf: 'flex-end' }}>
                        <button type="button" className="btn btn-primary" onClick={saveInvestigation} disabled={labSaving || selectedTests.length === 0}>
                          <i className="ri-save-line me-1"></i>{labRegId ? 'Update Investigation' : 'Save Investigation'}
                        </button>
                        &nbsp;
                        <button type="button" className="btn btn-dark" onClick={() => setShowLabPrintModal(true)} disabled={!labRegId || selectedTests.length === 0}>
                          <i className="ri-printer-line me-1"></i>Print Receipt
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </>
        )}

        {!patientLoaded && (
          <div className="card">
            <div className="card-body text-center py-5">
              <i className="ri-user-search-line" style={{ fontSize: 48, color: '#c8cfd8' }}></i>
              <h5 className="text-muted mt-3">Search and select a patient to begin billing</h5>
              <p className="text-muted">Use the search above to find a patient by UHID, Phone, or Name</p>
            </div>
          </div>
        )}

        {/* MULTI-PATIENT SELECTION MODAL */}
        {showPatientModal && (
          <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10000 }}>
            <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header bg-primary text-white">
                  <h5 className="modal-title"><i className="ri-group-line me-2" />Select Patient — {patientResults.length} found</h5>
                  <button type="button" className="btn-close btn-close-white" onClick={() => setShowPatientModal(false)} />
                </div>
                <div className="modal-body p-2">
                  {patientResults.map((p, idx) => {
                    const age = [
                      p.lab_reg_age_year ? `${p.lab_reg_age_year}Y` : '',
                      p.lab_reg_age_month ? `${p.lab_reg_age_month}M` : '',
                      p.lab_reg_age_day ? `${p.lab_reg_age_day}D` : '',
                    ].filter(Boolean).join(' ') || 'N/A';
                    return (
                      <div key={idx} className="p-3 mb-2 rounded" style={{ border: '1px solid #dee2e6', cursor: 'pointer', transition: 'background .15s' }}
                        onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
                        onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                        <div className="d-flex justify-content-between align-items-start">
                          <div style={{ flex: 1 }}>
                            <div className="fw-bold fs-6">{p.lab_reg_name_title} {p.lab_reg_name}</div>
                            <div className="text-muted mt-1" style={{ fontSize: 12 }}>
                              <span className="me-3"><i className="ri-fingerprint-line me-1" />UHID: <strong>{p.lab_reg_uhid}</strong></span>
                              <span className="me-3"><i className="ri-user-line me-1" />{age} / {p.lab_reg_gender}</span>
                              <span><i className="ri-phone-line me-1" />{p.lab_reg_mobile}</span>
                            </div>
                            <div className="mt-2">{renderVisitBadges(p)}</div>
                          </div>
                          <button type="button" className="btn btn-sm btn-primary ms-3" onClick={() => selectPatient(p)}><i className="ri-check-line me-1" />Select</button>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowPatientModal(false)}>Cancel</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* PROCEDURE PAYMENT MODAL */}
        {showProcPaymentModal && (
          <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10000 }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title"><i className="ri-money-dollar-circle-line me-2"></i>Add Payment</h5>
                  <button type="button" className="btn-close" onClick={() => setShowProcPaymentModal(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3"><label className="form-label">Due Amount</label>
                    <input type="text" className="form-control" value={`₹${parseFloat(procTotals.final_amount || 0).toFixed(2)}`} readOnly style={{ backgroundColor: '#e9ecef', fontWeight: 'bold', fontSize: '1.1rem' }} /></div>
                  <div className="mb-3"><label className="form-label">Payment Mode *</label>
                    <select className="form-control" value={procPaymentData.payment_mode} onChange={(e) => setProcPaymentData(prev => ({ ...prev, payment_mode: e.target.value }))}>
                      <option value="Cash">Cash</option><option value="Card">Card</option><option value="Online">Online</option>
                    </select></div>
                  <div className="mb-3"><label className="form-label">Payment Amount *</label>
                    <input type="number" className="form-control" placeholder="Enter amount" value={procPaymentData.amount}
                      onChange={(e) => setProcPaymentData(prev => ({ ...prev, amount: e.target.value }))} max={parseFloat(procTotals.final_amount)} step="0.01" min="0.01" />
                    <small className="text-muted">Maximum: ₹{parseFloat(procTotals.final_amount || 0).toFixed(2)}</small>
                    <div className="mt-2 d-flex gap-2">
                      <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setProcPaymentData(prev => ({ ...prev, amount: parseFloat(procTotals.final_amount || 0) }))}>Full Amount</button>
                      <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setProcPaymentData(prev => ({ ...prev, amount: (parseFloat(procTotals.final_amount || 0) / 2).toFixed(2) }))}>Half Amount</button>
                    </div>
                  </div>
                  <div className="mb-3"><label className="form-label">Received By</label>
                    <input type="text" className="form-control" value={procPaymentData.received_by} readOnly style={{ backgroundColor: '#e9ecef' }} /></div>
                  <div className="mb-3"><label className="form-label">Remarks</label>
                    <textarea className="form-control" rows="2" placeholder="Optional remarks" value={procPaymentData.remarks}
                      onChange={(e) => setProcPaymentData(prev => ({ ...prev, remarks: e.target.value }))}></textarea></div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowProcPaymentModal(false)}>Cancel</button>
                  <button type="button" className="btn btn-success" onClick={processProcPayment} disabled={procSaving}><i className="ri-check-line me-1"></i>Add Payment</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* INVESTIGATION PRINT OPTIONS MODAL */}
        {showLabPrintModal && (
          <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10000 }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Print Receipt</h5>
                  <button type="button" className="btn-close" onClick={() => setShowLabPrintModal(false)} aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <p className="mb-3">Choose header option for your receipt:</p>
                  <div className="form-check mb-2">
                    <input className="form-check-input" type="radio" name="labHeaderOption" id="labWithHeader" value="with" defaultChecked />
                    <label className="form-check-label" htmlFor="labWithHeader"><strong>With Header</strong>
                      <div className="text-muted small">Include hospital logo, header + Lab Copy + Radiology Copy</div></label>
                  </div>
                  <div className="form-check mb-3">
                    <input className="form-check-input" type="radio" name="labHeaderOption" id="labWithoutHeader" value="without" />
                    <label className="form-check-label" htmlFor="labWithoutHeader"><strong>Without Header</strong>
                      <div className="text-muted small">Plain receipt only (no Lab/Radiology copy pages)</div></label>
                  </div>
                  <hr />
                  <p className="mb-2 fw-bold">Copy Pages (only with "With Header"):</p>
                  <div className="form-check mb-2">
                    <input className="form-check-input" type="checkbox" id="labIncludeLabCopy" />
                    <label className="form-check-label" htmlFor="labIncludeLabCopy">Lab Copy</label>
                  </div>
                  <div className="form-check mb-2">
                    <input className="form-check-input" type="checkbox" id="labIncludeRadiologyCopy" />
                    <label className="form-check-label" htmlFor="labIncludeRadiologyCopy">Radiology Copy</label>
                  </div>
                  <hr />
                  <p className="mb-2 fw-bold">Print Layout (only with "With Header"):</p>
                  <div className="form-check mb-3">
                    <input className="form-check-input" type="radio" name="labPrintLayout" id="labLayoutSeparate" value="separate" defaultChecked />
                    <label className="form-check-label" htmlFor="labLayoutSeparate"><strong>Separate Pages</strong>
                      <div className="text-muted small">Patient Copy on page 1</div></label>
                  </div>
                  <div className="form-check mb-2">
                    <input className="form-check-input" type="radio" name="labPrintLayout" id="labLayoutSame" value="same" />
                    <label className="form-check-label" htmlFor="labLayoutSame"><strong>Same Page</strong>
                      <div className="text-muted small">Patient Copy + Office Copy on one A4 page (cut in middle)</div></label>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowLabPrintModal(false)}><i className="ri-close-line me-1"></i>Cancel</button>
                  <button type="button" className="btn btn-primary" onClick={() => {
                    const sel = document.querySelector('input[name="labHeaderOption"]:checked');
                    if (!sel) { toast.error('Please select a header option'); return; }
                    const headerOption = sel.value;
                    const includeLabCopy = document.getElementById('labIncludeLabCopy')?.checked || false;
                    const includeRadiologyCopy = document.getElementById('labIncludeRadiologyCopy')?.checked || false;
                    const layoutEl = document.querySelector('input[name="labPrintLayout"]:checked');
                    const printLayout = layoutEl ? layoutEl.value : 'separate';
                    generateInvestigationPDF(headerOption, includeLabCopy, includeRadiologyCopy, printLayout);
                    setShowLabPrintModal(false);
                  }}><i className="ri-printer-line me-1"></i>Proceed to Print</button>
                </div>
              </div>
            </div>
          </div>
        )}




{/* LAB PAYMENT MODAL */}
{showLabPayModal && (
  <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10000 }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title"><i className="ri-money-dollar-circle-line me-2"></i>Add Payment</h5>
          <button type="button" className="btn-close" onClick={() => setShowLabPayModal(false)}></button>
        </div>
        <div className="modal-body">
          <div className="mb-3"><label className="form-label">Due Amount</label>
            <input type="text" className="form-control" value={`₹${parseFloat(labTotals.due || 0).toFixed(2)}`} readOnly
              style={{ backgroundColor: '#e9ecef', fontWeight: 'bold', fontSize: '1.1rem' }} /></div>
          <div className="mb-3"><label className="form-label">Payment Mode *</label>
            <select className="form-control" value={labPayData.payment_mode}
              onChange={(e) => setLabPayData(prev => ({ ...prev, payment_mode: e.target.value }))}>
              <option value="Cash">Cash</option><option value="Card">Card</option><option value="Online">Online</option>
            </select></div>
          <div className="mb-3"><label className="form-label">Payment Amount *</label>
            <input type="number" className="form-control" placeholder="Enter amount" value={labPayData.amount}
              onChange={(e) => setLabPayData(prev => ({ ...prev, amount: e.target.value }))}
              max={parseFloat(labTotals.due)} step="0.01" min="0.01" />
            <small className="text-muted">Maximum: ₹{parseFloat(labTotals.due || 0).toFixed(2)}</small>
            <div className="mt-2 d-flex gap-2">
              <button type="button" className="btn btn-sm btn-outline-primary"
                onClick={() => setLabPayData(prev => ({ ...prev, amount: parseFloat(labTotals.due || 0).toFixed(2) }))}>Full Amount</button>
              <button type="button" className="btn btn-sm btn-outline-secondary"
                onClick={() => setLabPayData(prev => ({ ...prev, amount: (parseFloat(labTotals.due || 0) / 2).toFixed(2) }))}>Half Amount</button>
            </div>
          </div>
          <div className="mb-3"><label className="form-label">Received By</label>
            <input type="text" className="form-control" value={labPayData.received_by} readOnly style={{ backgroundColor: '#e9ecef' }} /></div>
          <div className="mb-3"><label className="form-label">Remarks</label>
            <textarea className="form-control" rows="2" placeholder="Optional remarks" value={labPayData.remarks}
              onChange={(e) => setLabPayData(prev => ({ ...prev, remarks: e.target.value }))}></textarea></div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={() => setShowLabPayModal(false)}>Cancel</button>
          <button type="button" className="btn btn-success" onClick={processLabPayment} disabled={labSaving}>
            <i className="ri-check-line me-1"></i>Add Payment</button>
        </div>
      </div>
    </div>
  </div>
)}
      </div>
    </div>
  );
}

export default OpBilling;